/**
 * @file routes.ts
 *
 * @fileoverview Include routes for the application.
 */
const jobiqoRoutesConfig = require('./../src/jobiqo/config/routes');
const mergeDeepRight = require('ramda/src/mergeDeepRight');

module.exports = mergeDeepRight(jobiqoRoutesConfig, {
  // Insert config here. this will be deep merged with config from jobiqo. Arrays are not deep mergeable
  // so make sure to cover those with [...jobiqoCompanyConfig.public.SOME_KEY_THAT_IS_ARRAY, new_item ]
  routes: [...jobiqoRoutesConfig.routes],
  removeQuerystringParams: [
    {
      source: '/jobs',
      removeQs: ['ajax_filter', 'job_type','sector_cat', 'skill_in', 'skill', 'sort-by', 'search_title', 'per-page', 'job_page'],
    },
    {
      source: '/organizations',
      removeQs: ['ajax_filter', 'employer_page', 'sort-by', 'per-page', 'search_title'],
    },
  ],
  redirects: [
    ...jobiqoRoutesConfig.redirects,
    // Redirect user login page.
    {
      source: '/anmelden',
      destination: '/user/login',
      permanent: true,
    },
    // Redirect old Arbeitgeber search page to Organizations search page.
    {
      source: '/arbeitgeber',
      destination: '/organizations',
      permanent: true,
    },
    // Redirect old Top arbeitgeber page to Organizations search page.
    {
      source: '/top-arbeitgeber',
      destination: '/organizations',
      permanent: true,
    },
    // Redirect indexed Resumes to homepage.
    {
      source: '/kandidaten',
      destination: '/',
      permanent: true,
    },
    {
      source: '/kandidaten/:slug*',
      destination: '/',
      permanent: true,
    },
    // Redirect Muensterland Jobs 24 page to job search page.
    {
      source: '/muensterlandjobs24',
      destination: '/jobs',
      permanent: true,
    },
    // Redirect old Top Job search page to the job search page.
    {
      source: '/top-jobs',
      destination: '/jobs',
      permanent: true,
    },
    // Redirect old User dashboard to homepage.
    {
      source: '/user-dashboard',
      destination: '/',
      permanent: true,
    },
    // Fix 404s alter launch.
    {
      source: '/suchergebnisse',
      destination: '/jobs',
      permanent: true,
    },
    {
      source: '/jobs-network/praktikum-sonneborn',
      destination: '/jobs',
      permanent: true,
    },
    {
      source: '/job-detailsuche',
      destination: '/jobs',
      permanent: true,
    },
    {
      source: '/stellenangebote',
      destination: '/jobs',
      permanent: true,
    },
    {
      source: '/register',
      destination: '/user/register',
      permanent: true,
    },
    // Additional redirect after 404 analysis.
    {
      source: '/stellenangebote/:path*',
      destination: '/jobs',
      permanent: true,
    },
    {
      source: '/muensterlandjobs24/:path*',
      destination: '/jobs',
      permanent: true,
    },
    {
      source: '/firmen/:path*',
      destination: '/arbeitgeber-suchen',
      permanent: true,
    },
  ],
});
